import * as React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BiEventParams,
  ClickProductFeatureTooltipLinkBiEvent,
} from 'services/BiLogger/BiLoggerTypes';
import { AdvancedPlansFeature } from 'types';
import { TextButton } from '@wix/design-system';

interface TooltipLinkProps {
  feature: AdvancedPlansFeature;
  onClick: (
    additionalParams: BiEventParams<ClickProductFeatureTooltipLinkBiEvent>,
  ) => void;
  size?: 'tiny' | 'small' | 'medium';
}

export const TooltipLink: React.FC<TooltipLinkProps> = ({
  feature,
  onClick,
  children,
  size = 'small',
}) => {
  const { t } = useTranslation();
  const urlKey = `${feature.displayProperties?.tooltipUrlKey}`;

  const handleClick = () => {
    onClick({ featureKey: feature.translationKey, url: urlKey });
  };

  return (
    <TextButton
      as='a'
      size={size}
      target='_blank'
      underline='onHover'
      href={t(urlKey)}
      onClick={handleClick}
    >
      {feature.displayProperties?.tooltipUrlKey && children}
    </TextButton>
  );
};
